/**
 * @generated SignedSource<<91ef500ec9c5f8c9971772ccab6598fa>>
 * @relayHash 295be01bda85ffc9613ed064ebb0fb04
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f816e8d0339243dc36afb0c7caa088b9f25023a2722f8a9ccbd74c097a5d7d5c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery } from './uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f816e8d0339243dc36afb0c7caa088b9f25023a2722f8a9ccbd74c097a5d7d5c",
    "metadata": {},
    "name": "uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
